import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import SkeletonBlock from '../../2-atoms/skeleton-block/skeleton-block';

import { modifierList } from './props-list';

const BannerMarketingSkeleton = ({ skeletonColor, bannerModifiers, skeletonModifiers }) => {
  const bannerClassNames = getClassNames('c-banner-marketing', bannerModifiers);

  return (
    <aside className={bannerClassNames}>
      <SkeletonBlock skeletonColor={skeletonColor} modifiers={skeletonModifiers} />
    </aside>
  );
};

BannerMarketingSkeleton.propTypes = {
  bannerModifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  skeletonModifiers: PropTypes.array,
  skeletonColor: PropTypes.string.isRequired,
};

export default BannerMarketingSkeleton;
